<template>
    <div>
        <div style="text-align: left;">请输入更换后的手机号码，进行验证</div>
        <Divider style="margin-top:0px;" />
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
            <FormItem label="手机号码" prop="tel" style="text-align: left;width: 94%;">
                <Input v-model="formCustom.tel" @on-change="showtips=false" placeholder="请输入手机号码..." />
            </FormItem>
            <FormItem label="短信验证" prop="sms">
                <Row>
                    <Col span="12"> <Input v-model="formCustom.sms" @on-change="showtips=false" placeholder="请输入验证码..." /></Col>
                    <Col span="12"><Button type="text" style="background:#F0F6FF;" @click="countDown" :disabled="!this.canClick">{{content}}</Button></Col>
                </Row>
            </FormItem>
            <FormItem>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
export default {
    data() {
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号码'));
            } else {
                if (this.checkPhone(value)) {
                    callback()
                } else {
                    callback(new Error('手机号码输入有误,请重新输入。'));
                }
            }
        };

        const validateSms = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入短信验证码'));
            } else {
                callback();
            }
        };
        return {
            formCustom: {
                tel: '',
                sms: '',
                smstypecode: 0,
            },
            ruleCustom: {
                tel: [
                    { validator: validateTel, trigger: 'blur' }
                ],
                sms: [
                    { validator: validateSms, trigger: 'blur' }
                ],
            },
            showtips: false,
            errmsg: '您所提交的信息有误,请重新输入',
            content: '发送验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            isSend: false,
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    methods: {
        countDown() {
            if (this.isSend) {
                //this.$Message.warning('短信已发送')
                return
            } else {
                this.isSend=true;

                if (!this.checkPhone(this.formCustom.tel)) {
                    this.$Message.warning('手机号码输入有误,请重新输入')
                    this.isSend = false
                    return
                }

                this.formCustom.smstypecode = this.$Tools.getSMSFrom().SMS_CODE_TYPE_VOLID_NEWPHONE
                regJ.reqSmsCode(this.formCustom.tel, this.formCustom.smstypecode).then(res => {
                    this.isSend=false
                    console.log(this.formCustom.tel)
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.$Message.info('验证码已发送')
                            console.log('验证码已发送')
                        } else {
                            this.$Message.error(res.rltdesc);
                            return
                        }
                    } else {
                        this.$Message.error(res.rtndesc);
                        return
                    }

                    if (!this.canClick) return //改动的是这两行代码
                    this.canClick = false
                    this.content = this.totalTime + 's后重新发送'
                    let clock = window.setInterval(() => {
                        this.totalTime--
                        this.content = this.totalTime + 's后重新发送'
                        if (this.totalTime < 0) {
                            window.clearInterval(clock)
                            this.content = '发送验证码'
                            this.totalTime = 60
                            this.canClick = true //这里重新开启
                        }
                    }, 1000)

                })
            }

        },
        checkPhone(phoneNum) {
            var phone = phoneNum;
            if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
                //alert("手机号码有误，请重填");  
                return false;
            } else {
                return true;
            }
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$emit('popCpsInfo', this.formCustom);
                } else {
                    this.$Message.error();
                    return
                }
            })
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
    },
}
</script>
<style lang="less" scoped>
</style>